"use client";
import React, { useState } from "react";
import Image from "next/image";
import { Link } from "../../../navigation";
import LocaleSwitcher from "../../portal/components/LocaleSwitcher";
import Icon from "../../common/components/Icon";
import TopNavigationLink from "./TopNavigationLink";
import { useTranslations } from "next-intl";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import AppContext from "../../theme/components/AppContext";
import CartSwitch from "../../portal/components/cart/CartSwitch";

const TopNavigation = ({ data }) => {
  const t = useTranslations();
  const [selected, setSelected] = useState(null);
  const { currentUser } = useCurrentUser();

  if (!data) return null;
  return (
    <div
      id="top-nav"
      className="d-flex align-items-center justify-content-between"
      aria-label={data.title}
    >
      <Link href="/">
        <Image
          src="/portal/img/publicare-logo.png"
          alt="Logo"
          width={230}
          height={35}
          className="hide-on-mobile"
        />
      </Link>
      <div className="w-100 mkt-top-nav d-flex flex-column justify-content-lg-end flex-lg-row gap-3">
        <LocaleSwitcher displayIs0={true} />
        <div className="ms-lg-4 my-4 my-lg-0 d-flex flex-column flex-lg-row gap-3">
          {data?.links
            .filter(({ url }) => {
              if (selected) return url?.route === selected;
              return true;
            })
            ?.map((item) => (
              <TopNavigationLink
                key={item.title}
                showSeparator
                href={typeof item.url === "string" ? item.url : item.url.route}
                target={item.target}
                showChildren={item?.meta?.showChildren}
                title={item.title}
                selected={selected}
                onSelected={(id) => setSelected(id)}
              >
                {item.title}
              </TopNavigationLink>
            ))}

          {/* <Link href="/anmelden" className="d-flex align-items-center gap-2">
            Anmelden
            <Icon icon="avatar-small" className="icon--md" />
          </Link> */}

          <TopNavigationLink href={!currentUser ? "/login" : "/portal"}>
            <div className="d-flex align-items-center justify-content-end flex-row-reverse flex-lg-row gap-2">
              {t("my_publicare")}
              <Icon icon="avatar-small" className="icon--md" />
            </div>
          </TopNavigationLink>
        </div>
      </div>
    </div>
  );
};

export default TopNavigation;
